import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import { ContextProvider } from "./context";
import App from './App';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <ContextProvider>
          <BrowserRouter>
              <App />
          </BrowserRouter>
      </ContextProvider>
  </React.StrictMode>
);
